module.exports = __webpack_public_path__ + "img/logo-icon-app.2d8f1ac7.png";